import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';

const DOCKET_ADMIN_URL = `${ADMIN_REST_API_BASE_URL}/docket`;
const PROGRAMMES_ADMIN_URL = `${ADMIN_REST_API_BASE_URL}/programmes`;

export interface AdminProgrammeDTO {
  id: number;
  code: string;
  displayName: string;
  description: string;
  modeCode: string;
  category: string;
  active: boolean;
  enrolmentCount: number;
}

export interface AdminProgrammeRequest {
  code?: string;
  displayName?: string;
  description?: string;
  modeCode?: string;
  category?: string;
}

// Programmes (Admin CRUD)
export const getAdminProgrammes = () =>
  apiClient.get<AdminProgrammeDTO[]>(PROGRAMMES_ADMIN_URL);

export const createAdminProgramme = (data: AdminProgrammeRequest) =>
  apiClient.post<AdminProgrammeDTO>(PROGRAMMES_ADMIN_URL, data);

export const updateAdminProgramme = (id: number, data: AdminProgrammeRequest) =>
  apiClient.put<AdminProgrammeDTO>(`${PROGRAMMES_ADMIN_URL}/${id}`, data);

export const deactivateAdminProgramme = (id: number) =>
  apiClient.put<AdminProgrammeDTO>(`${PROGRAMMES_ADMIN_URL}/${id}/deactivate`);

// Assignments
export const getAdminAssignments = (programmeCode: string) =>
  apiClient.get(`${DOCKET_ADMIN_URL}/programmes/${programmeCode}/assignments`);

export const createAdminAssignment = (programmeCode: string, data: any) =>
  apiClient.post(
    `${DOCKET_ADMIN_URL}/programmes/${programmeCode}/assignments`,
    data,
  );

export const updateAdminAssignment = (id: number, data: any) =>
  apiClient.put(`${DOCKET_ADMIN_URL}/assignments/${id}`, data);

export const deleteAdminAssignment = (id: number) =>
  apiClient.delete(`${DOCKET_ADMIN_URL}/assignments/${id}`);

// Questions
export const getAdminQuestions = (assignmentId: number) =>
  apiClient.get(`${DOCKET_ADMIN_URL}/assignments/${assignmentId}/questions`);

export const createAdminQuestion = (assignmentId: number, data: any) =>
  apiClient.post(
    `${DOCKET_ADMIN_URL}/assignments/${assignmentId}/questions`,
    data,
  );

export const updateAdminQuestion = (id: number, data: any) =>
  apiClient.put(`${DOCKET_ADMIN_URL}/questions/${id}`, data);

export const deleteAdminQuestion = (id: number) =>
  apiClient.delete(`${DOCKET_ADMIN_URL}/questions/${id}`);

export default apiClient;
